import { createContext, useContext } from 'react'

export interface MemberLayoutContextValue {
  scrollStageToTop: () => void
  bottomAddonTarget: HTMLElement | null
}

export const MemberLayoutContext = createContext<MemberLayoutContextValue | null>(null)

export const useMemberLayout = () => useContext(MemberLayoutContext)
